export default __webpack_public_path__ + "static/content-64be22f9efb371b80c57c93e5585e9da.jpg";